<div *ngFor="let err of errors | keyvalue">

    <div [ngSwitch]="err.key">
        <p *ngSwitchCase="'required'" class="mb-0">
            Campo requerido
        </p>
        <p *ngSwitchCase="'email'" class="mb-0">
            Favor de ingresar un e-mail válido
        </p>
        <p *ngSwitchCase="'mask'" class="mb-0">
            Favor de ingresar un dato válido. e.g. {{err['mask'].requiredMask}}
        </p>
        <p *ngSwitchCase="'minlength'" class="mb-0">
            El campo requiere un mínimo de {{err['requiredLength']}} caracteres
        </p>
        <p *ngSwitchCase="'validatePhoneNumber'" class="mb-0">
            Teléfono no valido
        </p>
        <p *ngSwitchCase="'greater-than'" class="mb-0">
            El valor no puede ser mayor al valor máximo
        </p>
        <p *ngSwitchCase="'lesser-than'" class="mb-0">
            El valor no puede ser menor al valor mínimo
        </p>
        <p *ngSwitchCase="'non-zero'" class="mb-0">
            El valor no puede ser 0
        </p>
        <p *ngSwitchCase="'equal-value'" class="mb-0">
            {{err['validationError']}}
        </p>
        <p *ngSwitchCase="'zipCodeNotFound'" class="mb-0">
            Código postal no encontrado en SEPOMEX
        </p>
        <p *ngSwitchCase="'invalidDateForCurp'" class="mb-0">
            La fecha en CURP no es válida
        </p>
        <p *ngSwitchCase="'invalidDateForRfc'" class="mb-0">
            La fecha en RFC no es válida
        </p>
        <p *ngSwitchCase="'rfcOrDateRequired'" class="mb-0">
           Debe capturar Fecha de Constitución o RFC
        </p>
        <p *ngSwitchDefault class="mb-0"> {{err.value}} </p>
    </div>
</div>